import type { PlatformPermission, SessionInfo, TenantPermission } from '@oms/contracts';

export type Permission = TenantPermission | PlatformPermission;

export interface Requirement {
  /** All of these are needed. */
  all?: Permission[];
  /** At least one of these is needed. */
  any?: Permission[];
}

export function hasPermission(permissions: readonly string[] | undefined, perm: Permission): boolean {
  return !!permissions?.includes(perm);
}

export function meets(permissions: readonly string[] | undefined, req: Requirement | undefined): boolean {
  if (!req) return true;
  const list = permissions ?? [];
  if (req.all && !req.all.every((p) => list.includes(p))) return false;
  if (req.any && req.any.length > 0 && !req.any.some((p) => list.includes(p))) return false;
  return true;
}

export const can = (session: SessionInfo | null | undefined, perm: Permission): boolean => hasPermission(session?.permissions, perm);
